import React from "react";
import PropTypes from "prop-types";
import { useTransition } from "react-spring";
import { useLocation, Switch } from "react-router-dom";

import Drawer from "./Drawer";

const DrawerSwitch = ({ keyForLocation, children, ...otherProps }) => {
  const location = useLocation();
  const transitions = useTransition(location, keyForLocation(location), {
    from: Drawer.closed,
    enter: Drawer.open,
    leave: Drawer.closed,
    unique: true,
    config: (_, type) =>
      type === "enter" ? { velocity: Drawer.initialVelocity } : { velocity: 0 }
  });

  return transitions.map(({ item, props, key }) => (
    <Drawer key={key} style={props} {...otherProps}>
      <Switch location={item}>{children}</Switch>
    </Drawer>
  ));
};

DrawerSwitch.propTypes = {
  children: PropTypes.node,
  keyForLocation: PropTypes.func
};

DrawerSwitch.defaultProps = {
  children: null,
  keyForLocation: location => location.pathname
};

export default DrawerSwitch;
